//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/pmUsers/views/main/lan/es';
import createUser from 'Modules/pmUsers/.components/createEditUser/lan/es';
import deleteUser from 'Modules/pmUsers/.components/deleteUser/lan/es';
import resetUser from 'Modules/pmUsers/.components/resetPassword/lan/es';
import jiraSummary from 'Modules/pmUsers/views/jiraSummary/lan/es';
import userDetails from 'Modules/pmUsers/views/jiraSummary/.components/userDetails/lan/es';

locales = { ...locales, ...main, ...createUser, ...deleteUser, ...resetUser, ...jiraSummary, ...userDetails };


export default locales;